module.exports = __webpack_public_path__ + "img/roundRightArrow.be281fce.svg";